import getLayoutRect from "@popperjs/core/lib/dom-utils/getLayoutRect";
import { beforeRead, read } from "@popperjs/core";
export const patchScaleFactorModifier = {
    enabled: true,
    name: "patchScaleFactor",
    phase: beforeRead,
    requires: ["popperOffsets"],
    fn: ({ state }) => {
        if (state.elements.reference instanceof HTMLElement) {
            state.rects.reference = getLayoutRect(state.elements.reference);
        }
    },
};
export const closeSelectPopover = (ref) => (hide) => {
    if (hide) {
        const { current } = ref;
        if (current) {
            const inputElement = (current?.inputElement ?? current?.input);
            if (inputElement) {
                if ("current" in inputElement && inputElement.current?.blur) {
                    inputElement.current.blur();
                }
                else if ("blur" in inputElement && inputElement.blur) {
                    inputElement.blur();
                }
                current?.handlePopoverInteraction(false);
            }
        }
    }
};
export const getHideListenerModifier = (onHide) => ({
    name: "hideListener",
    enabled: true,
    phase: read,
    fn(data) {
        setTimeout(() => onHide(!!data?.state?.modifiersData?.hide?.isReferenceHidden), 100);
    },
});
